fragment TaskSync on TaskSync {
    username
    externalService
    isEnabled
    syncErrors
}
